import styles from './FileUploadInput.module.scss';
import { Text } from '../typography';
import { useTranslation } from 'react-i18next';
import { keys } from '../../utilities/translator/translation_keys';
import { useState } from 'react';
import { blockedFileTypes, getExtension, isBlockedFile } from './utils';

//this is used to override the default file input modal for translation

export default function FileUploadInput({
  onChange,
  accept,
  multiple = false,
}) {
  const { t } = useTranslation();
  const [selectedFileNames, setSelectedFileNames] = useState('');

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files?.length > 0) {
      if (Array.from(files)?.length > 1) {
        const rejected = Array.from(files).filter(isBlockedFile);

        if (rejected.length) {
          alert(
            `These file types are not allowed: ${rejected
              .map((f) => f.name)
              .join(', ')}`,
          );
          return;
        }
      } else {
        const fileType = getExtension(files[0].name);
        if (blockedFileTypes.includes(fileType)) {
          alert(`This file type is not allowed: ${fileType}`);
          return;
        }
      }
      onChange(event);
      setSelectedFileNames(Array.from(files).map(({ name }) => name));
    } else {
      setSelectedFileNames('');
    }
  };
  return (
    <div className={styles.container}>
      <label>
        <Text
          noMargin
          weight="semiBold"
          className={styles.button}
          textAlign="center"
        >
          <input
            className={styles.hide}
            type={'file'}
            accept={accept || '*/*'}
            multiple={multiple}
            onChange={handleFileChange}
          />
          {t(keys.action.SELECT_VARIABLE, { variable: t(keys.common.FILE) })}
        </Text>
      </label>

      {selectedFileNames ? (
        selectedFileNames.map((name) => (
          <Text truncate key={name} noMargin className={styles.text}>
            {name}
          </Text>
        ))
      ) : (
        <Text noMargin>
          {t(keys.action.SELECTED, { variable: t(keys.common.NONE) })}
        </Text>
      )}
    </div>
  );
}
